/**
 * `addFields[].integration === 'zipcode'` — autopreenchimento de endereço via
 * ViaCEP, espelhando o snippet jQuery dos templates `invite*.ejs` do legado:
 * ao chegar em 8 dígitos, busca o CEP e preenche os campos de endereço
 * (slugs fixos abaixo) que existirem no próprio `passbook.fields`.
 */

export interface ViaCepResponse {
  logradouro?: string;
  bairro?: string;
  localidade?: string;
  uf?: string;
  estado?: string;
  erro?: boolean | string;
}

export function zipcodeDigits(value: string): string {
  return value.replace(/\D/g, '');
}

export async function fetchViaCep(cep: string, signal?: AbortSignal): Promise<ViaCepResponse | null> {
  try {
    const res = await fetch(`https://viacep.com.br/ws/${cep}/json/`, { signal });
    if (!res.ok) return null;
    const data = (await res.json()) as ViaCepResponse;
    return data.erro ? null : data;
  } catch {
    return null;
  }
}

/**
 * Valores por slug a preencher. Estado: o legado do emporiobrownie usa
 * `data.estado` (nome completo), os outros 23 templates usam `data.uf` —
 * prefere o nome completo e cai pra sigla se o ViaCEP não devolver.
 */
export function addressFromViaCep(data: ViaCepResponse): Record<string, string> {
  return {
    textEndereco: data.logradouro ?? '',
    textBairro: data.bairro ?? '',
    textEstado: data.estado || data.uf || '',
    textCidade: data.localidade ?? '',
  };
}
